"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObjectReferences = exports.flattenObjectReferences = exports.excludeObjectReference = void 0;
var core_1 = require("@newfront-insurance/core");
var excludeObjectReference = function (excludedObjectReference, objectReferenceTypes, objectReferenceIds) {
    var types = [];
    var ids = [];
    objectReferenceTypes.forEach(function (type, idx) {
        var _a;
        var excludedIndices = new Set((_a = excludedObjectReference[type]) !== null && _a !== void 0 ? _a : []);
        if (!excludedIndices.has(objectReferenceIds[idx])) {
            types.push(type);
            ids.push(objectReferenceIds[idx]);
        }
    });
    return { types: types, ids: ids };
};
exports.excludeObjectReference = excludeObjectReference;
var flattenObjectReferences = function (searchResults, exclusion) {
    var objectReferences = searchResults.map(function (_a) {
        var objectReferenceTypes = _a.objectReferenceTypes, objectReferenceIds = _a.objectReferenceIds;
        var _b = (0, exports.excludeObjectReference)(exclusion !== null && exclusion !== void 0 ? exclusion : {}, objectReferenceTypes !== null && objectReferenceTypes !== void 0 ? objectReferenceTypes : [], objectReferenceIds !== null && objectReferenceIds !== void 0 ? objectReferenceIds : []), types = _b.types, ids = _b.ids;
        return (0, core_1.toGroupedRecord)(types, function (type) { return type; }, function (_type, index) { return ids[index]; });
    });
    return objectReferences.flat();
};
exports.flattenObjectReferences = flattenObjectReferences;
var mergeObjectReferences = function () {
    var references = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        references[_i] = arguments[_i];
    }
    return references.reduce(function (mainRef, currentRef) {
        Object.entries(currentRef).forEach(function (_a) {
            var type = _a[0], identifiers = _a[1];
            var entries = new Set(mainRef[type]);
            identifiers === null || identifiers === void 0 ? void 0 : identifiers.forEach(function (identifier) {
                var _a;
                if (!entries.has(identifier)) {
                    if (!mainRef[type]) {
                        mainRef[type] = [identifier]; // eslint-disable-line
                    }
                    else {
                        (_a = mainRef[type]) === null || _a === void 0 ? void 0 : _a.push(identifier);
                    }
                }
            });
        });
        return mainRef;
    }, {});
};
exports.mergeObjectReferences = mergeObjectReferences;
